import React, { useCallback, useState } from "react";
import { get } from "lodash";
export default (({
  children,
  initialStep,
  initialStepId,
  initialData = {},
  onSubmit,
  onSubmitSuccess,
  onSubmitFailure
}) => {
  const [currentStepId, setStep] = useState(initialStep || initialStepId);
  const [data, setData] = useState(initialData);
  const addStepData = useCallback(object => {
    setData({ ...data,
      ...object
    });
  }, [data, setData]);
  const goToStep = useCallback(stepId => {
    setStep(stepId);
  }, [setStep]);
  const handleWizardSubmit = useCallback((onSubmit, props) => onSubmit(data, props), [data]);
  const submitWizard = useCallback(props => onSubmit({ ...data,
    ...get(props, "stepData")
  }).then(result => onSubmitSuccess && onSubmitSuccess({
    result,
    goToStep,
    data: { ...data,
      ...get(props, "stepData")
    }
  })).catch(e => {
    onSubmitFailure && onSubmitFailure(e); // don't propagate error further
  }), [data, onSubmit, onSubmitSuccess, onSubmitFailure, goToStep]);
  return /*#__PURE__*/React.cloneElement(React.Children.toArray(children).find(child => child.props.stepId === currentStepId), {
    addStepData,
    goToStep,
    data,
    handleWizardSubmit,
    submitWizard
  });
});